import axios from "axios"
import Utente from "../../interfaces/utente"

export const updateUtente = (id: number, formValues: Utente) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/UtenteOttico/${id}`, formValues)
      .then(() => {
        resolve(true)
      })
      .catch((error) => {
        reject(error.response.data.response)
      })
  })
}
export default updateUtente
